<modal-form-container
  title="Choose organizations"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="gm">
      <bk-group-picker kind="organization" [selected]="selectedOrganizations" (selectedChange)="onPick($event)" />

      <div class="gm__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <button type="button" class="bk-btn bk-btn--primary" (click)="emitSelection()">
          {{ selectedOrganizations.length ? 'Use ' + selectedOrganizations.length + ' selected' : 'Clear organizations' }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
